export default "__VITE_ASSET__62863506__"